module.exports = __webpack_public_path__ + "img/level_3.dce086b4.svg";